const IMAGE_PATH = '/images';

export const ImagesAssets = {
  splash: `${IMAGE_PATH}/robot.png`,
  darkLogo: `${IMAGE_PATH}/robot.png`,
  lightLogo: `${IMAGE_PATH}/robot.png`,
  logo: `${IMAGE_PATH}/mine.png`,

  onboarding1: `${IMAGE_PATH}/onboarding1.png`,
  onboarding2: `${IMAGE_PATH}/onboarding2.png`,
  onboarding3: `${IMAGE_PATH}/onboarding3.png`,

  // Services
  aiFeatures: `${IMAGE_PATH}/AI Features.png`,
  androidIosStorePublishing: `${IMAGE_PATH}/Android & iOS Store Publishing.png`,
  appMaintenanceService: `${IMAGE_PATH}/App Maintenance Service.png`,
  backendDevelopment: `${IMAGE_PATH}/Backend Development.png`,
  bugFixingOptimization: `${IMAGE_PATH}/Bug Fixing & Optimization.png`,
  electronicPaymentServices: `${IMAGE_PATH}/Electronic Payment Services.png`,
  mobileAppService: `${IMAGE_PATH}/Mobile App Service.png`,
  realtimeFeatures: `${IMAGE_PATH}/Realtime Features.png`,
  uiUxDesign: `${IMAGE_PATH}/UI:UX Design.png`,
  webServiceDashboard: `${IMAGE_PATH}/Web Service Dashboard.png`,

  robot: `${IMAGE_PATH}/robot.png`,
  robot2: `${IMAGE_PATH}/robot 2.png`,

  rLap: `${IMAGE_PATH}/r lap.png`,
  rMobile: `${IMAGE_PATH}/r mobile .png`,
  rAi: `${IMAGE_PATH}/r ai.png`,
  rBack: `${IMAGE_PATH}/r back.png`,
  rUi: `${IMAGE_PATH}/r ui.png`,
  rBug: `${IMAGE_PATH}/r bug.png`,
  rMain: `${IMAGE_PATH}/r maintenance.png`,
  rStore: `${IMAGE_PATH}/r store.png`,
  rReal: `${IMAGE_PATH}/r real.png`,
  rPay: `${IMAGE_PATH}/r pay.png`,

  cargo1: `${IMAGE_PATH}/Ca1 test.png`,
  cargo2: `${IMAGE_PATH}/ca2.png`,
  cargo3: `${IMAGE_PATH}/ca3.png`,
  cargo4: `${IMAGE_PATH}/ca4.png`,
  cargo5: `${IMAGE_PATH}/ca5.png`,
  cargo6: `${IMAGE_PATH}/ca6.png`,

  // JAEEK IMAGES
  jaeek1: `${IMAGE_PATH}/j1.png`,
  jaeek2: `${IMAGE_PATH}/j2.png`,
  jaeek3: `${IMAGE_PATH}/j3.png`,
  jaeek4: `${IMAGE_PATH}/j4.png`,
  jaeek5: `${IMAGE_PATH}/j5.png`,
  jaeek6: `${IMAGE_PATH}/j6.png`,
  jaeek7: `${IMAGE_PATH}/j7.png`,
  jaeek8: `${IMAGE_PATH}/j8.png`,
  jaeek9: `${IMAGE_PATH}/j9.png`,
  jaeek10: `${IMAGE_PATH}/j10.png`,
  jaeek11: `${IMAGE_PATH}/j11.png`,
  jaeek12: `${IMAGE_PATH}/j12.png`,
  jaeek13: `${IMAGE_PATH}/j13.png`,

  // MOALEME IMAGES
  moaleme1: `${IMAGE_PATH}/m1.png`,
  moaleme2: `${IMAGE_PATH}/m2.png`,
  moaleme3: `${IMAGE_PATH}/m3.png`,
  moaleme4: `${IMAGE_PATH}/m4.png`,
  moaleme5: `${IMAGE_PATH}/m5.png`,
  moaleme6: `${IMAGE_PATH}/m6.png`,
  moaleme7: `${IMAGE_PATH}/m7.png`,
  moaleme8: `${IMAGE_PATH}/m8.png`,
  moaleme9: `${IMAGE_PATH}/m9.png`,
  moaleme10: `${IMAGE_PATH}/m10.png`,

  // TABIBOK IMAGES
  tabibok1: `${IMAGE_PATH}/t1.png`,
  tabibok2: `${IMAGE_PATH}/t2.png`,
  tabibok3: `${IMAGE_PATH}/t3.png`,
  tabibok4: `${IMAGE_PATH}/t4.png`,
  tabibok5: `${IMAGE_PATH}/t5.png`,
  tabibok6: `${IMAGE_PATH}/t6.png`,
  tabibok7: `${IMAGE_PATH}/t7.png`,
  tabibok8: `${IMAGE_PATH}/t8.png`,
  tabibok9: `${IMAGE_PATH}/t9.png`,
  tabibok10: `${IMAGE_PATH}/t10.png`,
  tabibok11: `${IMAGE_PATH}/t11.png`,
  tabibok12: `${IMAGE_PATH}/t12.png`,

  // TAQSITI IMAGES
  taqsiti1: `${IMAGE_PATH}/tq1.png`,
  taqsiti2: `${IMAGE_PATH}/tq2.png`,

  // OMAYA IMAGES
  omaya1: `${IMAGE_PATH}/o1.png`,
  omaya2: `${IMAGE_PATH}/o2.png`,
  omaya3: `${IMAGE_PATH}/o3.png`,
  omaya4: `${IMAGE_PATH}/o4.png`,
  omaya5: `${IMAGE_PATH}/o5.png`,
  omaya6: `${IMAGE_PATH}/o6.png`,
  omaya7: `${IMAGE_PATH}/o7.png`,

  // FRIEND IMAGES
  friend1: `${IMAGE_PATH}/f1.png`,
  friend2: `${IMAGE_PATH}/f2.png`,
  friend3: `${IMAGE_PATH}/f3.png`,
  friend4: `${IMAGE_PATH}/f4.png`,
  friend5: `${IMAGE_PATH}/f5.png`,

  google: `${IMAGE_PATH}/mail.png`,
  linkedIn: `${IMAGE_PATH}/linked.png`,
  whatsapp: `${IMAGE_PATH}/whats.png`,
  github: `${IMAGE_PATH}/github.png`,
  gitlab: `${IMAGE_PATH}/gilab.png`,
};
